import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { RightOutlined } from '@ant-design/icons'
import styles from '../style.module.less'
import { open } from '@/utils/common'
import SPC121 from '@/assets/images/product/SPC121/详情页面第二张.png'
import CP203 from '@/assets/images/product/CP203/详情页面第二张.png'
import { productMap } from '@/assets/data'


const ProductHeader = () => {
  const navigator = useNavigate()
  const [productItems, setProductItems] = useState([])
  const [items] = useState([
    {
      label: 'Digital Pianos',
      key: 'DigitalPianos',
      items: [
        {
          pic: productMap.SPC121.pic,
          title: productMap.SPC121.title,
          id: productMap.SPC121.id
        },
        {
          pic: productMap.CP203.pic,
          title: productMap.CP203.title,
          id: productMap.CP203.id
        },
        {
          pic: productMap.SP201Plus.pic,
          title: productMap.SP201Plus.title,
          id: productMap.SP201Plus.id
        }
      ]
    },{
      label: 'Keyboards',
      key: 'Keyboards',
      items: [
        {
          pic: productMap.AKX10S.pic,
          title: productMap.AKX10S.title,
          id: productMap.AKX10S.id
        },
        // {
        //   pic: productMap.MK200.pic3,
        //   title: productMap.MK200.title,
        //   id: productMap.MK200.id
        // },
        {
          pic: productMap.MK61.pic3,
          title: productMap.MK61.title,
          id: productMap.MK61.id
        },
        {
          pic: productMap.MK37.pic3,
          title: productMap.MK37.title,
          id: productMap.MK37.id
        },
        {
          pic: productMap.MK49.pic3,
          title: productMap.MK49.title,
          id: productMap.MK49.id
        },
      ]
    },{
      label: 'Rhythm Machines',
      key: 'Drums',
      items: [
        {
          pic: productMap.MR101S.pic,
          title: productMap.MR101S.title,
          id: productMap.MR101S.id
        },
        {
          pic: productMap.tp110.pic,
          title: productMap.tp110.title,
          id: productMap.tp110.id
        },
      ]
    }
  ])

  const handleClick = useCallback((item) => {
    navigator('/category/' + item.key)
  }, [navigator])

  const handleDetail = useCallback((item) => {
    navigator('/product/detail/' + item.id)
  }, [navigator])

  const hndleMenuHover = useCallback((item) => {
    setProductItems(item.items || [])
  }, [])

  useEffect(() => {
    setProductItems(items[0].items)
  }, [items])

  return (
    <div className='ptb-60 bg-white text-333'>
      <div className='layout-container flex items-center'>
          <div className={styles['header-sub-menu']}>
            {
              items.map(item => (
                <div key={item.label} onClick={() => handleClick(item)} onMouseEnter={() => hndleMenuHover(item)}>
                  <div className='flex-1'>{item.label}</div>
                  <RightOutlined />
                </div>
              ))
            }
          </div>
          {
            productItems.map(item => (
              <div className='text-center mr-50 cursor-pointer'  onClick={() => handleDetail(item)} key={item.title}>
                <div className={styles['header-sub-menu-pic']} style={{backgroundImage: `url(${item.pic})`}}>
                </div>
                <div className='font-700 font-22'>
                  <span className='text-de underline'>{item.title}</span>
                </div>
              </div>
            ))
          }
          
      </div>
    </div>
  )
}

export default ProductHeader
